import { Temporal } from 'temporal-polyfill';
import { InferType, number, object, string } from 'yup';
import { isoDateStringField } from './isoDateStringField';

export const MetricsTransactionSchema = {
  base() {
    return {
      amount: number(),
      companyId: number(),
      createdAt: string(),
      createdBy: string(),
      cashDividendReceived: number(),
      cashInterestReceived: number(),
      currentInvestment: number(),
      dateModified: string(),
      dealId: string(),
      distributions: number(),
      dividends: number(),
      escrowAmount: number(),
      fundId: number().required(),
      id: number(),
      investmentAmount: number(),
      investmentRoundId: number(),
      ledgerId: number(),
      legalEntityId: number().nullable(),
      familyId: number().nullable(),
      position: string(),
      pps: number(),
      quantity: number(),
      restructureId: string(),
      roundId: number(),
      status: string().oneOf(['Pending', 'Confirmed']).required(),
      transactionDate: isoDateStringField(),
      transType: string(),
      transactionEntryId: string(),
      updatedAt: string(),
      updatedBy: string(),
      recallableAmount: number().required(),
      realizedValue: number(),
      realizedCost: number(),
      totalCost: number(),
      expenses: number(),
      capInterest: number(),
      restructureAmount: number(),
      stockProceeds: number(),
      rocAmount: number(),
    };
  },
  dataModel() {
    const base = this.base();

    return object({
      ...this.base(),
      amount: base.amount.required(),
      companyId: base.companyId.required(),
      currentInvestment: base.currentInvestment.required(),
      distributions: base.distributions.required(),
      id: base.id.required(),
      investmentAmount: base.investmentAmount.required(),
      quantity: base.quantity.required(),
      transactionDate: base.transactionDate.required(),
      transType: base.transType.required(),
    });
  },
};

export type MetricsTransactionDataModel = InferType<ReturnType<typeof MetricsTransactionSchema.dataModel>>;

export function createMetricsTransactionDataModel(
  overrides?: Partial<MetricsTransactionDataModel>
): MetricsTransactionDataModel {
  return {
    id: 0,
    companyId: 0,
    createdAt: '',
    distributions: 0,
    recallableAmount: 0,
    fundId: 0,
    investmentAmount: 0,
    currentInvestment: 0,
    transactionDate: Temporal.Now.plainDateISO().toString(),
    amount: 0,
    quantity: 0,
    transType: '',
    status: 'Pending',
    ...overrides,
  };
}
